import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);


const producto = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/proceso`,
    state: {
        procesos: []
    }
}).get({
    action: "get_procesosvisibles",
    path: function () {
        return `/procesosvisibles`;
    },
    onSuccess: (state, payload) => {
        state.procesos = payload.data;
    }
}).getStore();

producto.getters = {
    gprocesosactivos: state => {
        return state.procesos
    }
}
export default producto;
